module.exports = __webpack_public_path__ + "img/Deathknight-troll-m-70.56e4f2e9.gif";